import { TwinDictionary } from './dictionary';

export const parseAddressToOneLine = (address: TwinDictionary) => {
    if (!address) {
        return ''
    }
    const additionalAddress = address['additional_address'] || ''
    const addressStreet = address['address'] || ''
    const postalCode = address['postal_code'] || ''
    const city = address['city'] || ''
    return addressStreet + ' ' + additionalAddress + ' ' + postalCode + ' ' + city
}